import React from 'react';
import { Route } from 'react-router-dom';

import WithTracking from './WithTracking';

const TrackingRoute = props => <WithTracking {...props}><Route {...props} /></WithTracking>;

export default TrackingRoute;
